'use client';

import useProfileTutorialStatus from './models';

import { Tutorial as TutorialFeature } from '@/features/Landing';

const Tutorial = () => {
  const { data } = useProfileTutorialStatus();

  if (!data) return null;

  return (
    <TutorialFeature
      isScraped={data.isScraped}
      isHighlighted={data.isHighlighted}
      isSubscribedToAuthor={data.isSubscribedToAuthor}
    />
  );
};

export default Tutorial;
